export const base_url = "https://east1.wordaddin.compugrade.com"
// export const base_url = "https://dassadas.fsdfafs.ai"

// export const base_url = "https://37cf448022a4.ngrok-free.app"

export const admin_dashbaord_base_url = "https://production-api.dashboard.compugrade.com"

export const classroom_archive_password = "OSBlFwv5ouUd5H24"
